import { Check } from "lucide-react";

export const StepBar = ({ steps, current }) => (
  <div className="mb-8 flex items-center" data-testid="intake-stepbar">
    {steps.map((label, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <div key={label} className="flex flex-1 items-center last:flex-none">
          <div className="flex flex-col items-center">
            <div
              className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold transition-colors ${
                done ? "bg-success text-white" : active ? "bg-navy text-white" : "bg-secondary text-charcoal/50"
              }`}
            >
              {done ? <Check className="h-4 w-4" /> : i + 1}
            </div>
            <span className={`mt-2 hidden text-xs font-medium sm:block ${active ? "text-navy" : "text-charcoal/50"}`}>{label}</span>
          </div>
          {i < steps.length - 1 && (
            <div className={`mx-2 h-0.5 flex-1 ${done ? "bg-success" : "bg-border"}`} />
          )}
        </div>
      );
    })}
  </div>
);

export default StepBar;
